import React from 'react';
import { motion } from 'framer-motion';
import StatBar from './StatBar';
import skills from '../../data/skills';
import SectionReveal from './SectionReveal';

const AboutSectionV2 = () => (
	<section id="about" className="py-24 bg-ink/90">
		<SectionReveal className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
			<div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
				<motion.div
					initial={{ opacity: 0, x: -24 }}
					whileInView={{ opacity: 1, x: 0 }}
					viewport={{ once: true, amount: 0.3 }}
					transition={{ duration: 0.6 }}
				>
					<div className="font-mono text-xs uppercase tracking-[0.3em] text-rpgblue mb-2">
						Character Stats
					</div>
					<h2 className="font-display text-3xl font-semibold mb-4 text-gold">About Me</h2>
					<p className="text-lg text-gray-400 mb-8">
						I'm Sam Togun, a Senior Backend Engineer &amp; Solutions Architect. I specialize in building scalable, reliable backend systems and cloud solutions for modern businesses.
					</p>
					<div className="space-y-5">
						{skills.map(skill => (
							<StatBar key={skill.label} label={skill.label} value={skill.value} />
						))}
					</div>
				</motion.div>
				<motion.div
					initial={{ opacity: 0, scale: 0.92 }}
					whileInView={{ opacity: 1, scale: 1 }}
					viewport={{ once: true, amount: 0.3 }}
					transition={{ duration: 0.6 }}
					className="flex justify-center"
				>
					<div className="p-2 rounded-3xl bg-gradient-to-br from-gold via-rpgblue to-gold shadow-[0_0_40px_rgba(201,164,74,0.25)]">
						<img
							src="https://i.ibb.co/60cRjycV/pana-886777-img-only.jpg"
							alt="Sam Togun"
							className="rounded-[1.3rem] w-70 h-70 object-cover border-2 border-ink"
						/>
					</div>
				</motion.div>
			</div>
		</SectionReveal>
	</section>
);

export default AboutSectionV2;
